import { BrowserRouter, Routes, Route } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import Login from "./components/Login";
import Users from "./pages/users/Users";
import AddUser from "./pages/users/AddUser";
import EditUser from "./pages/users/EditUser";
import Products from "./pages/products/Products";
import AddProduct from "./pages/products/AddProduct";
import EditProduct from "./pages/products/EditProduct";
import Category from "./pages/categories/Category";
import AddCategory from "./pages/categories/AddCategory";
import EditCategory from "./pages/categories/EditCategory";
import Client from "./pages/clients/Client";
import AddClient from "./pages/clients/AddClient";
import EditClient from "./pages/clients/EditClient";
import Contract from "./pages/contracts/Contract";
import AddContract from "./pages/contracts/AddContract";
import ShowContract from "./pages/contracts/ShowContract";
import AddContractPayment from "./pages/contracts/AddPayment";
import Ticket from "./pages/tickets/Ticket";
import EditTicket from "./pages/tickets/EditTicket";
import AddTicket from "./pages/tickets/AddTicket";
import Myticket from "./pages/mytickets/myticket";
import AddMyTicket from "./pages/mytickets/AddMyTicket";
import EditMyTicket from "./pages/mytickets/EditMyTicket";
import Services from "./pages/services/Service";
import AddService from "./pages/services/AddService";
import EditService from "./pages/services/EditService";
import Company from "./pages/companies/Company";
import AddCompany from "./pages/companies/AddCompany";
import EditCompany from "./pages/companies/EditCompany";
import ShowPayment from "./pages/contracts/ShowPayment";
import ChangeProfile from "./pages/profiles/ChangeProfile";
import ShowService from "./pages/services/ShowService";
import MyHistory from "./pages/myhistories/MyHistory";
import DetailHistory from "./pages/myhistories/DetailHistory";
import Homepages from "./pages/Homepage";
import ReportTicket from "./pages/reporttickets/ReportTicket";
import ReportService from "./pages/reportservices/ReportService";
import Register from "./components/Register";
import Ads from "./pages/ads/Ads";
import AddAds from "./pages/ads/AddAds";
import EditAds from "./pages/ads/EditAds";

function App() {
  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Homepages />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/categories" element={<Category />} />
          <Route path="/categories/add" element={<AddCategory />} />
          <Route path="/categories/edit/:id" element={<EditCategory />} />
          <Route path="/clients" element={<Client />} />
          <Route path="/clients/add" element={<AddClient />} />
          <Route path="/clients/edit/:id" element={<EditClient />} />
          <Route path="/companies" element={<Company />} />
          <Route path="/companies/add" element={<AddCompany />} />
          <Route path="/companies/edit/:id" element={<EditCompany />} />
          <Route path="/users" element={<Users />} />
          <Route path="/users/add" element={<AddUser />} />
          <Route path="/users/edit/:id" element={<EditUser />} />
          <Route path="/products" element={<Products />} />
          <Route path="/products/add" element={<AddProduct />} />
          <Route path="/products/edit/:id" element={<EditProduct />} />
          <Route path="/contracts" element={<Contract/>} />
          <Route path="/contracts/add" element={<AddContract />} />
          <Route path="/contracts/detail/:id" element={<ShowContract />} />
          <Route path="/contracts/detail-payment/:id" element={<ShowPayment />} />
          <Route path="/contracts/payment/:id" element={<AddContractPayment />} />

          <Route path="/tickets" element={<Ticket/>} />
          <Route path="/tickets/add" element={<AddTicket />} />
          <Route path="/tickets/edit/:id" element={<EditTicket />} />
          <Route path="/producttickets/edit/:id" element={<EditTicket />} />
          <Route path="/mytickets" element={<Myticket/>} />
          <Route path="/mytickets/add" element={<AddMyTicket />} />
          <Route path="/mytickets/edit/:id" element={<EditMyTicket />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/add" element={<AddService />} />
          <Route path="/services/edit/:id" element={<EditService />} />
          <Route path="/services/detail/:id" element={<ShowService />} />
          <Route path="/profiles/edit/:id" element={<ChangeProfile />} />
          <Route path="/myhistories" element={<MyHistory/>} />
          <Route path="/myhistories/detail/:id" element={<DetailHistory />} />
          <Route path="/reporttickets" element={<ReportTicket />} />
          <Route path="/reportservices" element={<ReportService />} />

          <Route path="/ads" element={<Ads />} />
          <Route path="/ads/add" element={<AddAds />} />
          <Route path="/ads/edit/:id" element={<EditAds />} />
         
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
